
import React from 'react'
import ReactDOM from 'react-dom';
import ModalContainer from '../Modal';
function createModalElement(prizes, modalInfo) {
  const div = document.createElement('div');
  console.log('append')
  document.body.appendChild(div);
  console.log('div',div)
  const modal = ReactDOM.render(<ModalContainer />, div);
  console.log('with modal append div', modal)
  return {
    addModal() {
      return modal.addModal(prizes, modalInfo, div)
    }
  }

}

let modal
const withModal = (prizes, modalInfo) => {
  modal = createModalElement(prizes, modalInfo)
  return modal.addModal()
}

export default {
  show(prizes, modalInfo) { return withModal(prizes, modalInfo) }
}